import React, { PureComponent } from 'react';
import { XAxis, YAxis, Tooltip, ResponsiveContainer, LineChart, Line, LabelList, Legend } from 'recharts';
import PropTypes from 'prop-types';

// Cumulative Runs Per Over
export default class Worm extends PureComponent {
    render() {
        const { data, innings1battingteam, innings2battingteam, innings1colour, innings2colour, foregroundColor, oversLabel } = this.props;

        return (
            <ResponsiveContainer width="100%" height={250}>
                <LineChart
                    data={ data }
                    margin={{
                        top: 30,
                        bottom: 30,
                        left: -30,
                        right: 20
                    }}
                >
                    <Legend verticalAlign="top" align="right" height={36}/>
                    <XAxis dataKey="over" label={{ value: oversLabel, position: 'bottom', fill: foregroundColor }} stroke={foregroundColor}/>
                    <YAxis domain={ [0, dataMin => Math.ceil(dataMin / 10) * 10] } allowDecimals={ false } stroke={foregroundColor}/>
                    <Tooltip content={ <CustomTooltip/> }/>
                    { innings1battingteam &&
                        <Line dataKey="innings1TotalRuns" name={innings1battingteam} stroke={innings1colour} dot={false} isAnimationActive={false}>
                            <LabelList dataKey="innings1Wickets" content={(props) => renderWickets(props, innings1colour)} />
                        </Line>
                    }
                    { innings2battingteam &&
                        <Line dataKey="innings2TotalRuns" name={innings2battingteam} stroke={innings2colour} dot={false} isAnimationActive={false}>
                            <LabelList dataKey="innings2Wickets" content={(props) => renderWickets(props, innings2colour)} />
                        </Line>
                    }
                </LineChart>
            </ResponsiveContainer>
        );
    }
}

const renderWickets = (props, color) => {
    const { x, y, value } = props;
    const radius = 4;

    if (value < 1) {
        return null;
    }

    const circles = [];
    for (let i = 0; i < value; i++) {
        circles.push(<circle key={i} cx={x} cy={y - (radius * 2 * i) - 1} r={radius} stroke={color} strokeWidth={2} fill='none' />)
    }

    return (
        <g>
            {circles}
        </g>
    );
};

const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        return (
            <div style={{
                padding: '10px',
                background: 'white',
                border: '1px solid black',
                color: 'black'
            }}>
                <div style={{ marginBottom: '10px' }}>Over {label}</div>
                { payload.map((p, i) => {
                    if (p.value) {
                        return (
                            <div style={{ color: p.color }} key={i}>
                                {p.name}: {p.value} / {p.payload[`innings${i+1}Wickets`]}
                            </div>
                        )
                    }
                    return null;
                })}
            </div>
        )
    }
    return null;
};

Worm.propTypes = {
    data: PropTypes.array.isRequired,
}
